import { Box, Button, Card, CardActions, CardContent, MenuItem, Stack } from '@mui/material';
import { WccDto, WCC_STATUSES_MAP, WccStatus, WCC_STATUSES_ARRAY, INCOMING_WCC_STATUSES_ARRAY, OUTCOMING_WCC_STATUSES_ARRAY, getWccStatusesArrayByInvoiceType, InvoiceType } from '@sr/dto';
import { useSnack } from 'shared/ui/snack';
import { FormValues, formTools } from './wcc-basic-supplier.form-tools';
import { Field, Formik, FormikProps } from 'formik';
import { DatePickerField } from 'shared/ui/formik-fields/date-picker';
import { TextField, Select } from 'formik-mui';
import { useSignerDialog } from 'shared/providers/legal-entities.provider';
import { SignerPicker } from 'shared/ui/formik-fields/signer-picker';
import FilePickerField from 'shared/ui/formik-fields/file-picker';
import { invoiceWccApi } from 'features/invoice/invoice-wcc/invoice-wcc.api';
import { fetchWcc } from 'features/invoice/invoice-wcc/api';
import { extractNestJsErrorMessage } from 'shared/api/rtk-query';
type WccStatusKey = keyof typeof WCC_STATUSES_MAP;
export const WccBasicsForm = ({ wcc, legalEntityId, onUpdated }: { wcc: WccDto, legalEntityId: number; onUpdated: (wcc: WccDto) => void; }) => {

  const { showSuccess, showError } = useSnack();

  const sellerSignerDialog = useSignerDialog(legalEntityId);
  const [updateInvoiceSupplierWcc] = invoiceWccApi.useUpdateInvoiceSupplierWccMutation();
  const currentStatuses = getWccStatusesArrayByInvoiceType(wcc.invoice.type as InvoiceType);
  const currentStatusKeys: WccStatusKey[] = (Object.values(WccStatus) as WccStatusKey[])
    .filter((status): status is WccStatusKey =>
      currentStatuses.some((el) => el.id === status)
    );


  const handleSubmit = async (formData: FormValues) => {
    return updateInvoiceSupplierWcc(formTools.toUpdateDto(wcc.id, formData)).unwrap()
      .then(async () => {
        const updatedWcc = await fetchWcc(wcc.id);
        onUpdated(updatedWcc);
        showSuccess('Данные акта успешно обновлены');
      })
      .catch(e => {
        showError(`Ошибка обновления данных акта: ${extractNestJsErrorMessage(e)}`);
      });
  };

  return (
    <Card>
      <Formik
        initialValues={formTools.fromDto(wcc)}
        enableReinitialize
        onSubmit={handleSubmit}
        validate={formTools.validate}
      >
        {({ submitForm, isSubmitting, dirty }: FormikProps<FormValues>) => (
          <>
            <CardContent>
              <Stack direction="column" spacing={2}>
                <Field
                  name="wccNumber"
                  component={TextField}
                  label="Номер Акта"
                  required
                />

                <Field
                  name="date"
                  label="Дата акта"
                  component={DatePickerField}
                />

                <Field
                  name="amount"
                  component={TextField}
                  label="Сумма акта"
                />

                <Field
                  name="status"
                  label="Статус"
                  component={Select}
                >

                  {currentStatusKeys.map((status) => (
                    <MenuItem key={status} value={status}>
                      {WCC_STATUSES_MAP[status]}
                    </MenuItem>
                  ))}
                </Field>

                <Field
                  label='Главный бухгалтер'
                  component={SignerPicker}
                  legalEntityId={legalEntityId}
                  collection={sellerSignerDialog.collection}
                  name='sellerSignerId' />
                <Box>
                  Файл Акта
                  <Field
                    name='aktFile'
                    fileCategory="akt-scan"
                    component={FilePickerField}
                    multiple
                  />
                </Box>
                <Box>
                  Файл УПД
                  <Field
                    name='updFile'
                    fileCategory="upd-scan"
                    component={FilePickerField}
                    multiple
                  />
                </Box>
                <Box>
                  Доп. файлы
                  <Field
                    name='otherFiles'
                    fileCategory="wcc-other-files"
                    component={FilePickerField}
                    multiple
                  />
                </Box>
              </Stack>
            </CardContent>
            <CardActions>
              <Button
                variant="contained"
                sx={{ ml: 'auto', mr: 1 }}
                onClick={submitForm}
                disabled={!dirty || isSubmitting}
              >
                Сохранить
              </Button>
            </CardActions>
          </>
        )}
      </Formik>
    </Card >
  );
};
